import styled from "styled-components/macro";
import { Button as MuiButton, IconButton } from "@mui/material";
import { alertActionButtonStyles } from "../AlertActionButton.styles";
import { themePalette } from "../../theme";

export const RedrawHeaderButton = styled(MuiButton)`
  && {
    background: transparent;
    border: 2px solid ${themePalette.redMedium};
    border-radius: 30px;
    color: ${themePalette.redMedium};
    padding: 4px 16px;
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;

    &:hover {
      background: ${themePalette.redMedium};
      color: white;
    }
  }
`;

export const RedrawTable = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 24px 16px 24px;
  border: 1px solid ${themePalette.neutral200};
  border-radius: 8px;
  overflow: hidden;
`;

export const RedrawTableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.5fr 100px;
  background: ${themePalette.white};
  border-bottom: 1px solid ${themePalette.neutral100};
  padding: 0 20px;
  height: 44px;
  align-items: center;
`;

export const RedrawRow = styled.div<{ $placed?: boolean }>`
  display: grid;
  grid-template-columns: 1fr 1.5fr 100px;
  padding: 0 20px;
  height: 44px;
  align-items: center;
  cursor: ${({ $placed }) => ($placed ? "pointer" : "default")};
  background: ${themePalette.white};
  box-sizing: border-box;
  &:not(:last-child) {
    border-bottom: 1px solid ${themePalette.neutral100};
  }
  &:hover {
    background: ${themePalette.greenPastel};
  }
`;

export const RedrawCell = styled.div<{ $placed?: boolean; $heading?: boolean }>`
  font-size: ${({ $heading }) => ($heading ? "12px" : "14px")};
  font-weight: ${({ $heading, $placed }) => {
    if ($heading) return "600";
    if ($placed) return "500";
    return "400";
  }};
  color: ${({ $heading, $placed }) => {
    if ($heading) return themePalette.neutral500;
    if ($placed) return "#017E72";
    return themePalette.neutral700;
  }};
  text-transform: ${({ $heading }) => ($heading ? "uppercase" : "none")};
  letter-spacing: ${({ $heading }) => ($heading ? "0.5px" : "normal")};
  display: flex;
  align-items: center;
`;

export const RedrawActionsCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
`;

export const RedrawIconButton = styled(IconButton)`
  && {
    padding: 0;
    font-size: 13px;
    box-shadow: none;
    ${alertActionButtonStyles}
  }
`;

export const PlaceAllButton = styled.button`
  background: transparent;
  color: ${themePalette.redMedium};
  border: none;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 30px;
  transition: background 0.2s;
  &:hover {
    background: ${themePalette.redPastel};
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    &:hover {
      background: transparent;
    }
  }
`;

export const ViewOrdersButton = styled(PlaceAllButton)``;

export const HighlightText = styled.span`
  color: ${themePalette.blueDark};
  font-weight: 600;
`;

export const ErrorMessage = styled.div`
  color: ${themePalette.redDark};
  font-size: 14px;
  text-align: left;
  margin: 8px 24px 16px 0px;
`;

export const TooltipText = styled.div`
  margin-top: 4px;
  font-size: 14px;
  padding: 3px;
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;

export const FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
`;
